import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const STAFF_API = `${BACKEND_URL}/api/library/staff`;

const TOKEN_KEY = "madaris_staff_token";

export const getStaffToken = () => localStorage.getItem(TOKEN_KEY);
export const setStaffToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearStaffToken = () => localStorage.removeItem(TOKEN_KEY);

export const staffApi = axios.create({ baseURL: STAFF_API });

staffApi.interceptors.request.use((config) => {
  // For staff-authenticated endpoints (their own dashboard, folders, files)
  const t = getStaffToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

staffApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) clearStaffToken();
    return Promise.reject(err);
  }
);

// Admin-authenticated staff endpoints use the LIBRARY admin token
import { getToken } from "@/library/lib/api";

export const staffAdminApi = axios.create({ baseURL: STAFF_API });

staffAdminApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
